import React from "react";
import { AccountSummaryData } from "../AccountSummary.slice";
import { ServiceAccountLabel } from "./ServiceAccountLabel";

interface PropsInterface {
  accounts: AccountSummaryData[];
  className?: string;
  renderLabel?: (account: AccountSummaryData) => React.ReactNode;
}

export const ModalAccountList: React.FC<PropsInterface> = ({
  accounts,
  className = "mb-3 modal-account-list",
  renderLabel,
}) => {
  if (accounts.length === 0) {
    return null;
  }

  return (
    <ul className={className}>
      {accounts.map((account) => (
        <li key={account.id}>
          {renderLabel ? (
            renderLabel(account)
          ) : (
            <ServiceAccountLabel
              account={account}
              className="modal-account-list-item"
            />
          )}
        </li>
      ))}
    </ul>
  );
};
